import React from "react";
import { Helmet } from "react-helmet";
import VidHero from "../components/VidHero";
import Hero from "../components/Hero";
import Feature from "../components/Feature";
import Demo from "../components/Demo";
import About from "../components/About";
import Services from "../components/Services";
import Counter from "../components/Counter";
// import Portfolio from "../components/Portfolio";
import Marquee from "../components/Marquee";
// import Team from "../components/Team";
import Projectcta from "../components/Projectcta";
import Award from "../components/Award";
import Testimonial from "../components/Testimonial";
import FaqAccordion from "../components/FaqAcordian";
import BlogSection from "../components/BlogSection";

const Home = ({ component }) => {
  const faqData =  [
    { question: "What services do you offer in web development?", answer: "We provide custom web development, MERN Development, e-commerce solutions, website redesign, UI/UX design, and WordPress development. Our team ensures responsive and SEO-friendly designs for optimal performance." },  //1
    { question: "How can social media marketing grow my business?", answer: "Social media marketing increases brand awareness, drives website traffic, generates leads, and boosts customer engagement. We create data-driven strategies tailored to your business goals." },
    { question: "What platforms do you use for social media marketing?", answer: "We specialize in marketing on Facebook, Instagram, LinkedIn, Twitter, and YouTube, using content marketing, paid ads, and analytics-driven strategies to maximize your reach." },                                  
    { question: "How long does it take to develop a website?", answer: "The timeline depends on the project scope. A basic website takes 2-4 weeks, while complex platforms may take 6-12 weeks. We ensure timely delivery without compromising quality." },                                        //4
    { question: "How does SEO impact my website ranking?", answer: "SEO improves your website’s visibility on search engines, driving organic traffic. Our SEO services include keyword research, on-page optimization, link building, and technical SEO enhancements." },
    { question: "Do you provide content marketing services?", answer: "Yes, we create blog posts, infographics, social media content, and video marketing strategies to enhance your brand authority and drive organic traffic to your website." },
    { question: "How can I get started with your services?", answer: "Simply contact us through our website or email, and our team will guide you through the process of choosing the right services based on your business goals." },                                                                  //10
    { question: "What is an Instagram grid, and why is it important?", answer: "An Instagram grid is the visual arrangement of your posts on your profile. A well-structured grid enhances brand aesthetics, improves engagement, and creates a cohesive look that attracts potential followers and customers." },  
    { question: "How do you design an effective Instagram grid?", answer: "We create Instagram grids using a planned color scheme, content themes, and a balanced mix of visuals, ensuring consistency and branding alignment. We use carousel posts, quote graphics, and storytelling techniques to engage your audience." },
    { question: "What are the charges for influencer marketing?", answer: "Our influencer marketing charges are 10% of the influencer's payment. Actual charges may vary based on campaign scope, influencer reach, and engagement level." }
];
  // Build FAQPage JSON-LD schema for rich snippets
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <title>Om Softwares - Best Digital Marketing & Web Development Agency | Nangal, Punjab</title>
        <meta name="description" content="Om Softwares specializes in social media marketing, web development, visual branding, and SEO services. Boost your online presence with the best digital marketing agency in Nangal, Una, Hoshiarpur, Punjab." />
        <meta property="og:title" content="Om Softwares - Digital Marketing & Web Development Agency" />
        <meta property="og:description" content="Om Softwares specializes in social media marketing, visual branding, and web development. Boost your online presence with us." />
        <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
        <meta property="og:url" content="https://omsoftwares.in/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Om Softwares - Digital Marketing & Web Development Agency" />
        <meta name="twitter:description" content="Om Softwares specializes in social media marketing, visual branding, and web development." />
        <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Om Softwares",
          "url": "https://omsoftwares.in",
          "logo": "https://omsoftwares.in/logo.png",
          "sameAs": [
            "https://www.instagram.com/omsoftwares.in/",
            "https://www.facebook.com/omsoftwares1",
            "https://www.linkedin.com/company/omsoftwares1/",
            "https://github.com/omsoftwares1/"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-62398-62469",
            "contactType": "Customer Service",
            "email": "omsoftwareandtechnologies@gmail.com",
            "areaServed": "IN",
            "availableLanguage": ["English", "Hindi"]
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Nangal",
            "addressRegion": "Punjab",
            "addressCountry": "IN"
          }
        })}</script>
      </Helmet>
      <main>
        {component === "VidHero" ? <VidHero /> : <Hero />}
        <Feature />
        <Demo />
        <About />
        <Services />
        <Counter />
        <FaqAccordion faqData={faqData}/>
        {/* <Portfolio /> */}
        <Marquee />
        {/* <Team /> */}
        <Projectcta />
        <Award />
        <Testimonial />
        <BlogSection/>
              </main>
    </>
  );
};

export default Home;
